module["exports"] = [
  "küç.",
  "küçəsi",
  "prospekti",
  "pr.",
  "sahəsi",
  "sh."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/address/street_suffix.js
// module id = 171
// module chunks = 0